import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { NuxContainer } from 'us-react-components/dist/NuxContainer/NuxContainer';
import details from '../../../images/animations/details.json';
import { Routes } from '../../../Routes';
import { useDependencies } from '../../../dependencies';
import { LottieComponent, LottieComponentProps } from '../../../types/LottieComponent';

export const Great: LottieComponent<LottieComponentProps> = observer((props: LottieComponentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { stores: { familyRegistration }, services: { tracker } } = useDependencies();
  const { useLottie } = props;

  familyRegistration.setCurrentRoute(Routes.parent.registration.great);

  const handleContinue = (): void => {
    navigate(Routes.parent.registration.selectDateTimes)
  }

  const options = {
    animationData: details,
    loop: false,
    style: {
      height: '237px',
      width: '237px',
    }
  };

  const { View } = useLottie(options);

  return (
    <NuxContainer
      inverted
      familyRegistration={familyRegistration}
      navigate={navigate}
      tracker={tracker}
      onContinue={handleContinue}
      title={t('pages.nux.family.great.title')}>
      <div className='pt-4 xs:pt-16 sm:pt-20'>
        {View}
      </div>
    </NuxContainer>
  )
});
